import { Component, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-custom-dialog',
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule],
    templateUrl: './custom-dialog.component.html',
})
export class CustomDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<CustomDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            title?: string;
            message?: string;
            innerHTML?: string;
            yes?: string;
            cancel?: string;
        }
    ) {
        this.data.yes = this.data.yes || 'Aceptar';
        this.data.cancel = this.data.cancel || 'Cancelar';
    }
}